import React from 'react'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'

const ItemStyle = styled.div`
  h4 {
    font-size: 2rem;
    font-weight: ${fontWeight.medium};
    margin-top: 0;
    margin-bottom: 16px;
  }
  @media (max-width: ${breakPoints.md.max}px) {
    padding: 16px 0;
    text-align: center;
    h4 {
      font-size: 1.25rem;
      margin-bottom: 8px;
    }
  }
  @media (min-width: ${breakPoints.lg.min}px) {
    padding: 64px 0;
  }
`

const Content = styled.div`
  font-size: 20px;
  p {
    &:last-child {
      margin-bottom: 0;
    }
  }
  @media (max-width: ${breakPoints.md.max}px) {
    font-size: 1rem;
    p {
      margin-bottom: 8px;
    }
  }
`

const Item = ({ heading, content }) => {
  const newContent = content.split('\n').map((item, i) => <p key={i}>{item}</p>)
  return (
    <ItemStyle className='wow fadeIn'>
      <h4>{heading}</h4>
      <Content>{newContent}</Content>
    </ItemStyle>
  )
}

export default Item
